import React from "react";
import { Menu, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SubmenuItem } from "./subMenus";
import { IconName, IconProp } from "@fortawesome/fontawesome-svg-core";

interface SidebarSubMenuProps {
  iconName?: string;
  titleLabel?: string;
  link?: string;
  onTitleClick?: () => void;
  subMenu: SubmenuItem[];
  onLink: (x: string, y: string) => void;
  isActive: (x: string) => boolean;
}

export const SidebarSubMenu: React.FC<SidebarSubMenuProps> = ({
  iconName,
  titleLabel,
  link,
  subMenu,
  onLink,
  isActive,
  ...rest
}) => {
  const renderSubMenu = (subMenu: SubmenuItem[]) => {
    const renderIcon = (item: SubmenuItem) => {
      if (item.icon) {
        return typeof item.icon === "string" ? (
          <div className="sidebar-icon">
            <FontAwesomeIcon icon={["fas", item.icon] as IconProp} fixedWidth={true} size="lg" />
          </div>
        ) : (
          item.icon
        );
      }
      return null;
    };
    if (subMenu) {
      return subMenu.map((item) => (
        <Menu.Item
          className={`${
            (item.isActive ? item.isActive(`${link}/${item.link}`) : isActive(`${link}/${item.link}`))
              ? "ant-menu-item-selected"
              : ""
          }`}
          key={`${link}/${item.link}`}
        >
          <Tooltip title={item.message} placement="right">
            <div onClick={() => onLink(null, `${link}/${item.link}`)} className="sidebar-link">
              {renderIcon(item)}
              {item.label}
            </div>
          </Tooltip>
        </Menu.Item>
      ));
    } else {
      return null;
    }
  };
  return (
    <Menu.SubMenu
      {...rest}
      popupClassName="hidden"
      key={link}
      className={`${isActive(link) ? "ant-menu-item-selected" : ""}`}
      title={
        <div onClick={() => onLink(link, null)} className="sidebar-link text-ellipsis">
          <div className="sidebar-icon">
            <FontAwesomeIcon
              icon={["far", iconName as IconName] as IconProp}
              size="lg"
              fixedWidth={true}
              style={{ marginRight: 12 }}
            />
          </div>
          <span>{titleLabel}</span>
        </div>
      }
    >
      {renderSubMenu(subMenu)}
    </Menu.SubMenu>
  );
};
